import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ComponentsModule } from '../../lib/components.module';
import { MaterialModule } from '../../lib/material.module';
import { ProductCardComponent, ProductFiltersComponent, ProductPickerComponent, ProductTileComponent } from './components';
import { ProductTechnicalDataPipe } from './pipes';
import { API_PLANNING_PROJECTS_CONFIG, ApiPlanningProjectsConfig, createProductsService } from './api-plannig-projects.config';
import { ProductsService } from './services/products.service';

const COMPONENTS = [ProductCardComponent, ProductPickerComponent, ProductFiltersComponent, ProductTileComponent];

const PIPES = [ProductTechnicalDataPipe];

@NgModule({
    declarations: [...COMPONENTS, ...PIPES],
    imports: [CommonModule, ReactiveFormsModule, ComponentsModule, TranslateModule, MaterialModule],
    exports: [...COMPONENTS, ...PIPES]
})
export class ProductsModule {
    static forRoot(config: ApiPlanningProjectsConfig): ModuleWithProviders<ProductsModule> {
        return {
            ngModule: ProductsModule,
            providers: [
                {
                    provide: API_PLANNING_PROJECTS_CONFIG,
                    useValue: config
                },
                {
                    provide: ProductsService,
                    useFactory: createProductsService,
                    deps: [API_PLANNING_PROJECTS_CONFIG, HttpClient]
                }
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: ProductsModule, @Optional() http: HttpClient) {
        if (!http) {
            throw new Error('You need to import the HttpClient in your AppModule!');
        }
    }
}
